import styled from "styled-components";
import { ReactComponent as CalendarIconSVG } from 'assets/svgs/calendar.svg';
import { colors } from "colors";

export const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  
  .SingleDatePicker,
  .SingleDatePicker > div,
  .SingleDatePickerInput,
  .DateInput {
    display: flex;
    flex: 1;
  }
  
  .SingleDatePicker input {
    font-size: 14px;
    padding: 10px;
    border-top: 1px solid ${colors.silver};
    border-right: 1px solid ${colors.silver};
    border-bottom: 1px solid ${colors.silver};
    border-left: 0;
    border-radius: 0 4px 4px 0;
    outline: none;
    line-height: normal;
  }
  
  .SingleDatePicker input::before {
    content: 'asdasd';
    width: 24px
  }
  
  
  .SingleDatePicker input::placeholder {
    color: lightgrey;
    font-size: 14px;
  }
  
  .CalendarDay__selected,
  .CalendarDay__selected:active,
  .CalendarDay__selected:hover {
    background: ${colors.brightBlue}
  }
`;

export const InputWrapper = styled.div`
  display: flex;
  align-items: flex-start;
  
`;

export const CalendarIcon = styled(CalendarIconSVG)`
  padding: 10px;
  width: 16px;
  height: 16px;
  object-fit: contain;
  fill: ${colors.slateGrey};
  background-color: ${colors.lightGrey};
  border-radius: 4px 0 0 4px;
  border: 1px solid ${colors.silver};
  cursor: pointer;
`;

export const Label = styled.label`
  font-size: 14px;
  color: ${colors.slateGrey};
 
  &[required] {
    ::after {
      content: " *";
      color: ${colors.strawberry};
    }
  }
`;
